import { ApplicationMessage } from '../../core/models/application-message';
import { MessageType } from '../../core/models/enum/message-type';
import { ApplicationMessageSource } from '../../core/models/application-message-source';
import { CustomMessageService } from '../../core/message.service';
import { ValidationUtils } from '../../shared/validation/validation-runner';
import {
  IPromise,
  IValidator,
  MessageLevel,
  Validator,
} from '../../shared/validation/validators';
import { FieldState } from '../../shared/models/field-state';
import { PortfolioService } from '../shared/services/portfolio.service';
import { PortfolioModel } from '../shared/models/portfolio-model';
import { LookupService } from '../../shared/services/lookup.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-portfolio-edit-name',
  templateUrl: './portfolio-edit-name.component.html',
  styleUrls: ['./portfolio-edit-name.component.less'],
  standalone: false,
})
export class PortfolioEditNameComponent implements OnInit {
  constructor(
    private lookupService: LookupService,
    private portfolioService: PortfolioService,
    private translationService: TranslateService,
    private messageService: CustomMessageService
  ) {}

  @Input()
  public isInEditMode: boolean = false;
  @Input()
  public portfolio: PortfolioModel;

  @Output()
  public onEdit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public onUpdate: EventEmitter<any> = new EventEmitter<any>();

  public newName: string;

  public fieldStates: { newName: FieldState };

  public get field() {
    return this.fieldStates;
  }

  public initializeFieldsState() {
    this.fieldStates = {
      newName: new FieldState(() => this.newName),
    };
  }

  public invokeValidation(validators: IValidator[], onValid?: () => void) {
    ValidationUtils.invokeValidation(
      validators,
      this.getFieldStatesObject(),
      onValid
    );
  }

  private getFieldStatesObject(): { [index: string]: FieldState } {
    let result: { [index: string]: FieldState } = {};
    for (let p in this.fieldStates) {
      if (this.fieldStates.hasOwnProperty(p)) {
        result[this.fieldStates[p].fieldId] = this.fieldStates[p];
      }
    }
    return result;
  }

  private getValidators() {
    let field = this.field;
    let newName = this.newName;

    let emptyMessage = this.translationService.instant(
      'message.ValueLeftEmpty'
    );
    let incorrectFormat = this.translationService.instant(
      'message.IncorrectFormat'
    );
    let isAlreadyInUse = this.translationService.instant(
      'message.IsAlreadyInUse'
    );

    return [
      Validator.forRequired(field.newName, () => newName, emptyMessage),
      this.isInEditMode
        ? Validator.forAsync(
            field.newName,
            () => {
              var p = this.portfolioService.validatePortfolioName(newName);
              return <IPromise>{
                catch: (error) => p.catch(error),
                then: (data) => p.then(data),
                finally: () => {
                  alert('todo');
                },
              };
            },
            (response: any) => {
              var isValid = response.isSuccess;
              return {
                message: isValid ? null : isAlreadyInUse,
                level: isValid ? null : MessageLevel.Error,
                isValid: isValid,
              };
            }
          )
        : Validator.forBypass(field.newName),
    ];
  }

  public onEditPortfolioNameClick() {
    this.isInEditMode = true;
  }

  public onCancelClick() {
    this.isInEditMode = false;
    this.initializeFieldsState();
  }

  public onUpdatePortfolioNameClick() {
    let portfolio = this.portfolio;
    let validators = this.getValidators();
    this.invokeValidation(validators, () => {
      this.portfolioService
        .savePortfolioName(this.newName, this.portfolio.portfolioId)
        .subscribe(() => {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Success,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: this.translationService.instant('message.SaveMessage'),
          });
        });
      this.onUpdate.emit(portfolio);
      this.onCancelClick();
    });
  }

  ngOnInit() {
    this.newName = null;
    this.initializeFieldsState();
  }
}
